import React from 'react';
import { ResizedLogo } from '@apps/createWedding/components/JoyLogo/JoyLogo.styles';

export const JoyLogo = () => {
  return <ResizedLogo />;
};
